import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import InfiniteScroll from 'react-infinite-scroller';

import { fetchWishlist } from 'Redux/ducks/wishlist';
import { fetchAnonWishlist } from 'Redux/ducks/anon-wishlist';
import ProductRecommendations from 'Containers/Product/ProductRecommendations';
import WishlistCard from 'Components/Wishlist/WishlistCard';
import WishlistSelingPoints from 'Components/Wishlist/WishlistSellingPoints';

const messages = defineMessages({
  recommended_for: {
    id: 'MyWishlist.recommededforyou',
    defaultMessage: 'Recommended For You',
  },
});

const MyWishlistContainer = ({
  intl: { formatMessage },
  view,
  sort,
  fetchWishlist: propFetchWishlist,
  page,
  nbPages,
  items,
  authenticated,
  fromAccount,
  setEmptyWishlist,
  fetchAnonWishlist: _fetchAnonWishlist,
}) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasItems, setHasItems] = useState(false);

  useEffect(() => {
    const loadWishlist = async () => {
      await propFetchWishlist(sort, 1);
      return setHasLoaded(true);
    };

    const loadAnonWishlist = async () => {
      await _fetchAnonWishlist(sort, 1);
      return setHasLoaded(true);
    };

    if (!authenticated) loadAnonWishlist();
    if (authenticated) loadWishlist();
  }, [sort, propFetchWishlist, authenticated, _fetchAnonWishlist]);

  useEffect(() => {
    if (isEmpty(items)) {
      setEmptyWishlist(true);
      setHasItems(false);
    } else {
      setEmptyWishlist(false);
      setHasItems(true);
    }
  }, [items, setEmptyWishlist]);

  if (!hasLoaded) return false;

  return (
    <div className="my-wishlist-container">
      {!hasItems &&
        <React.Fragment>
          <WishlistSelingPoints />
          {!fromAccount &&
            <ProductRecommendations
              forceTopSellers
              title={formatMessage(messages.recommended_for)}
            />
          }
        </React.Fragment>
      }

      {hasItems && (view === 'list') &&
        <div className="infinite-wrap" key={page}>
          <InfiniteScroll
            pageStart={page || 1}
            loadMore={async (pageValue) => {
              if (authenticated) await propFetchWishlist(sort, pageValue);
              if (!authenticated) await _fetchAnonWishlist(sort, pageValue);
            }}
            hasMore={!!(items.length && page < nbPages)}
            initialLoad={false}
            loader={<div className="infinite-loader" key={0}>
              <div className="spinner">
                <div className="rect1" />
                <div className="rect2" />
                <div className="rect3" />
                <div className="rect4" />
                <div className="rect5" />
              </div>
            </div>}
          >

            {items.map(hit =>
              <div key={hit.objectID}>
                <WishlistCard
                  hit={hit}
                  key={hit.objectID}
                />
              </div>,
            )}
          </InfiniteScroll>
        </div>
      }
    </div>
  );
};


MyWishlistContainer.propTypes = {
  sort: PropTypes.string.isRequired,
  view: PropTypes.string,
  fetchWishlist: PropTypes.func.isRequired,
  authenticated: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
  page: PropTypes.number,
  nbPages: PropTypes.number,
  fromAccount: PropTypes.bool,
  setEmptyWishlist: PropTypes.func.isRequired,
  fetchAnonWishlist: PropTypes.func.isRequired,
};

MyWishlistContainer.defaultProps = {
  authenticated: false,
  view: 'list',
  page: 0,
  nbPages: 0,
  items: [],
  fromAccount: false,
};

const mapStateToProps = ({
  router: { location },
  auth: { authenticated },
  wishlist: { count, items, page, nbPages },
}) => ({
  location,
  count,
  items,
  authenticated,
  page,
  nbPages,
});

const mapDispatchToProps = {
  fetchWishlist,
  fetchAnonWishlist,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MyWishlistContainer));
